export default function isEmpty(obj: Record<string, unknown> | null | undefined): boolean {
	if (!obj) {
		return true;
	}
	return obj.constructor === Object && Object.keys(obj).length === 0;
}
